module.exports = __webpack_public_path__ + "img/lipan.e475450a.png";